import {NgModule} from '@angular/core';
import {SessionService} from '../api-2/session.service';
import {DexApiDraftDbService} from './dex-api-draft-db.service';

@NgModule({
    providers: [
        DexApiDraftDbService,
        SessionService
    ]
})
export class DexApiDraftDbModule {}
